/**
 * Created by rickborst on 18/07/2017.
 */

import {ActionTypes} from '../../actions/modals/forgotpassword';

const ModalStates = {
        INITIAL: 'INITIAL',
        REQUESTING_RESET: 'REQUESTING_RESET',
        REQUEST_FAILED: 'REQUEST_FAILED',
        REQUEST_SUCCESS: 'REQUEST_SUCCESS'
    },

    defaultState = {
        status: ModalStates.INITIAL,
        submitError: null
    };

/**
 * Sets the new status on the state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} New state.
 */
function setStatus (state, action) {

    return {
        ...state,
        status: action.status
    };
}

/**
 * Sets the new error on the state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} New state.
 */
function setSubmitError (state, action) {

    return {
        ...state,
        submitError: action.error
    };
}

/**
 * Returns the current state or new states when actions apply.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} Current/new state.
 */
export default function forgotPassword (state = defaultState, action) {

    switch (action.type) {

        case ActionTypes.SET_FORGOT_PASSWORD_STATUS:
            return setStatus(state, action);

        case ActionTypes.SET_FORGOT_PASSWORD_ERROR:
            return setSubmitError(state, action);

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/modals/forgotpassword.js